import { createRouter, createWebHistory } from 'vue-router';
import { useFavicon } from '@vueuse/core';
import { useUserStore, useCreativeStore, useAuthStore, useAppStore } from '@/common/store';
import routes from './routes';
import { tracker as worker } from '../workers';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeResolve(async () => {
  const appStore = useAppStore();
  // console.log(to.matched.find((n) => n.name === to.name).components.default);
  appStore.isLoading = false;

  const icon = useFavicon();
  icon.value = `${process.env.BASE_URL}favicon-studio-16092022.ico`;
});

router.beforeEach(async (to, from, next) => {
  const appStore = useAppStore();
  const authStore = useAuthStore();
  const isProtected = to.matched.slice().reverse().find((r) => r.meta && r.meta.protected);
  appStore.isLoading = true;

  // check the user has access or a token in local storage
  const hasAccess = await authStore.checkAuth();
  if (!hasAccess && isProtected) return next({ name: 'SignInView' });

  // Validate if the route is protected
  if (!isProtected) return next();
  const userStore = useUserStore();
  const creativeStore = useCreativeStore();

  // Fetch user info
  await userStore.getUserInfo();

  const { permissions } = userStore.currentUser;
  const isUserExists = Object.entries(userStore.currentUser).length > 0;

  // Validate if user isn't exist or if doesn't have roles
  if (!isUserExists || permissions.length === 0 || !permissions) return next({ name: 'SignInView' });

  // track user activity so we dont log out the user in the API
  worker.postMessage({ token: authStore.token });

  if (to.name === 'MainView' && permissions.length > 0) {
    creativeStore.$reset();

    // Validate if currentUser has the permissions to view companies
    if (!userStore.isAdmin) {
      return next({ name: 'CreativesListView' });
    }

    return next({ name: 'CompaniesListView' });
  }

  return next();
});

export default router;
